import { render, staticRenderFns } from "./archived-table.vue?vue&type=template&id=0486cd6c&scoped=true&"
import script from "./archived-table.vue?vue&type=script&lang=js&"
export * from "./archived-table.vue?vue&type=script&lang=js&"
import style0 from "./archived-table.vue?vue&type=style&index=0&id=0486cd6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0486cd6c",
  null
  
)

component.options.__file = "archived-table.vue"
export default component.exports